import moment from "moment";
import IReactSelectValue from "../../../interfaces/IReactSelectValue";
import { HolidaySelection, PlaceFilterRequest } from "./requests/placeFilterRequest";

export default class ReservationInsightsFilter {

    triggerUpdate: number = 0;
    venues: IReactSelectValue[];
    floors?: IReactSelectValue[];
    rooms?: IReactSelectValue[];
    workPlaces?: IReactSelectValue[];

    workspaceOrAndRoom?: IReactSelectValue; // UI

    startDate?: Date;
    endDate?: Date;

    startHourOfTheDay?: number;
    endHourOfTheDay?: number;
    weekdays?: IReactSelectValue[];
    weeks?: IReactSelectValue[];

    allPlaceTypes?: IReactSelectValue[];

    workplaceTypes?: IReactSelectValue[];
    roomTypes?: IReactSelectValue[];

    departments?: IReactSelectValue[];
    holidaysAsList?: IReactSelectValue[]; ;

    constructor(
        triggerUpdate?: number,
        departments?: IReactSelectValue[],
        endDate?: Date,
        floors?: IReactSelectValue[],
        fromTime?: number,
        holidaysAsList?: IReactSelectValue[],
        places?: IReactSelectValue[],
        startDate?: Date,
        toTime?: number,
        placeTypes?: IReactSelectValue[],
        venues?: IReactSelectValue[],
        weekdays?: IReactSelectValue[],
        weeks?: IReactSelectValue[],
        workspaceOrAndRoom?: IReactSelectValue
    ) {
        this.triggerUpdate = triggerUpdate || 0;
        this.departments = departments || [];
        this.endDate = endDate || new Date();
        this.floors = floors || [];
        this.startHourOfTheDay = fromTime || 0;
        this.holidaysAsList = holidaysAsList;
        this.workPlaces = places || [];
        this.startDate = startDate || new Date(2024, 0, 1);
        this.endHourOfTheDay = toTime || 24;
        this.allPlaceTypes = placeTypes || [];
        this.venues = venues || [];
        this.weekdays = weekdays;
        this.weeks = weeks;
        this.workspaceOrAndRoom = workspaceOrAndRoom;
    }
}

export function mapToPlaceFilterRequest(filter: ReservationInsightsFilter): PlaceFilterRequest {
    return {
        departments: filter.departments?.map(d => d.value) || [],
        endDate: moment(filter.endDate).format("YYYY-MM-DD"),
        floors: filter.floors?.map(f => f.value) || [],
        startHourOfTheDay: filter.startHourOfTheDay,
        holidays: mapHolidays(filter),
        rooms: filter.rooms?.map(r => r.value) || [],
        workplaces: filter.workPlaces?.map(w => w.value) || [],
        includeRooms: filter.workspaceOrAndRoom?.value === "both" || filter.workspaceOrAndRoom?.value === "rooms",
        includeWorkplaces: filter.workspaceOrAndRoom?.value === "both" || filter.workspaceOrAndRoom?.value === "workplaces",
        startDate: moment(filter.startDate).format("YYYY-MM-DD"),
        endHourOfTheDay: (filter.endHourOfTheDay! - 1),
        roomTypes: filter.allPlaceTypes?.filter(rt => rt.value.indexOf("room_") !== -1).map(r => r.label) || [],
        workplaceTypes: filter.allPlaceTypes?.filter(pt => pt.value.indexOf("workplace_") !== -1).map(w => w.label) || [],
        venues: filter.venues?.map(v => v.value) || [],
        weekdays: filter.weekdays?.map(wd => Number(wd.value)) || [],
        weeks: filter.weeks?.map(w => StripYearFromWeek(w.value)) || [],
    }
}

function StripYearFromWeek(week: string): number {
    return Number(week.substring(4, 6)); // Temp workaround for missing year in week api call.
}

export function mapHolidays(filter: ReservationInsightsFilter): HolidaySelection {
    return {
        includeNewYearsDay: filter.holidaysAsList?.some(h => h.value === "newYearsDay") || false,
        includeGoodFriday: filter.holidaysAsList?.some(h => h.value === "goodFriday") || false,
        includeFirstEasterDay: filter.holidaysAsList?.some(h => h.value === "firstEasterDay") || false,
        includeSecondEasterDay: filter.holidaysAsList?.some(h => h.value === "secondEasterDay") || false,
        includeKingsDay: filter.holidaysAsList?.some(h => h.value === "kingsDay") || false,
        includeAscensionDay: filter.holidaysAsList?.some(h => h.value === "ascensionDay") || false,
        includeWhitSunday: filter.holidaysAsList?.some(h => h.value === "whitSunday") || false,
        includeWhitMonday: filter.holidaysAsList?.some(h => h.value === "whitMonday") || false,
        includeFirstChrismasDay: filter.holidaysAsList?.some(h => h.value === "firstChrismasDay") || false,
        includeSecondChrismasDay: filter.holidaysAsList?.some(h => h.value === "secondChrismasDay") || false
    }
}